import { onTransitionEnd } from '../helpers/ontransitionend';

export default class Tooltips {
    constructor($trigger) {
        this.$trigger = $trigger;
        this.$body = document.body;

        if (!this.$trigger) {
            return;
        }

        this.init();
    }

    init() {
        this.eventTriggerTooltip();
    }

    /**
     * build layout for tooltip window
     * @param content - content from html
     */
    buildContentWindow(content) {
        return `
            <div class="tt-window">
                <div class="tt-window__inner">${content}</div>
            </div>
        `;
    }

    /**
     * set position to current visible tooltip
     */
    setPosition() {
        const triggerTop = this.$trigger.getBoundingClientRect().top;
        const triggerLeft =  this.$trigger.getBoundingClientRect().left;
        const $window = this.$body.querySelector('.tt-window');
        const windowYOffset = window.pageYOffset;
        const arrowSize = 20;
        let top;
        let left;

        if (triggerTop + $window.offsetHeight < windowYOffset + window.innerHeight) {
            top = triggerTop + windowYOffset + this.$trigger.offsetHeight + arrowSize;
            $window.classList.add('tt-window--arrow-up');
        } else {
            top = triggerTop + windowYOffset - $window.offsetHeight - arrowSize;
            $window.classList.add('tt-window--arrow-bottom');
        }


        left = triggerLeft + (this.$trigger.offsetWidth / 2) - ($window.offsetWidth / 2);

        $window.style.cssText = `
            top: ${top}px;
            left: ${left}px;
        `;
    }

    /**
     * return DOM objects with curren tooltip window
     * for small performance look for tooltips only in body childrens
     */
    getTooltipFromDom() {
        return [...document.querySelectorAll('body > .tt-window')];
    }

    /**
     * create and open tooltip
     */
    open() {
        const content = this.$trigger.getAttribute('data-tt-content').trim();

        if (content.length === 0 || content === 'None') {
            return;
        }

        // To be sure if everything will be fine remove all previously added tooltips
        this.getTooltipFromDom().forEach(($tt) => $tt.remove());

        const $windowTemplate = this.buildContentWindow(content);

        this.$trigger.classList.add('tt-active');
        this.$body.insertAdjacentHTML('beforeend', $windowTemplate);

        this.setPosition();

        const $window = this.getTooltipFromDom()[0];
        if ($window) {
            $window.classList.add('tt-window--visible');
        }
    }

    /**
     * close and remove from DOM current visible tooltip
     */
    close() {
        const [$window] = this.getTooltipFromDom().filter(($tt) => $tt.classList.contains('tt-window--visible'));
        this.$trigger.classList.remove('tt-active');

        if ($window) {
            $window.classList.remove('tt-window--visible');

            onTransitionEnd($window).then(() => {
                $window.remove();
            });
        }
    }

    eventTriggerTooltip() {
        this.$trigger.addEventListener('mouseenter', () => this.open());

        this.$trigger.addEventListener('mouseleave', () => this.close());
        
        this.$body.addEventListener('touchstart', () => this.close());
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/tooltips.js